import Image from "next/image";
import { FESTIVAL_TYPE } from "@features/landing/types";
import { festivalImage } from "@features/landing/helpers/constants/festival-image";
import classNames from "classnames";
import { festivalStyles } from "@features/landing/helpers/constants/festival-styles";

interface Props {
  theme: FESTIVAL_TYPE;
}

const HeroLeftSide: React.FC<Props> = ({ theme }) => {
  return (
    <div
      className={classNames(
        "mr-auto ml-auto sm:ml-0 lg:w-[450px] lg:basis-[450px]  sm:w-[216px] sm:basis-[216px] z-5",
        festivalStyles[theme].leftImageParent
      )}
    >
      <div className={classNames("mr-auto", festivalStyles[theme].leftImage)}>
        <Image
          src={festivalImage[theme].leftImage}
          alt="festival-left-banner"
          fill
        />
      </div>
    </div>
  );
};

export default HeroLeftSide;
